import React from "react";

const Condition = (props: any) => {
  return <React.Fragment>{props.when ? props.children : null}</React.Fragment>;
};

export default Condition;
